import { render } from "./ListeSecteurActivitePage.vue?vue&type=template&id=08059384&ts=true"
import script from "./ListeSecteurActivitePage.vue?vue&type=script&lang=ts"
export * from "./ListeSecteurActivitePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__